import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getMessage = unaryRpc({
  name: "getMessage",
  input: z.object({ name: z.string().optional() }),
  output: z.object({ message: z.string(), timestamp: z.string() }),
});
